module.exports = __webpack_public_path__ + "img/plane-icon.5dd0829b.png";